import React, { useState, useEffect } from "react";
import { getReq, delReq, putReq } from "../middleware/AxiosApisCall";
import { SuccessAlert, ErrorAlert } from "../middleware/AlertMsg";
import { AiFillDelete } from "react-icons/ai";
import { MdModeEditOutline } from "react-icons/md";
import Loading from "../Loading";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  IconButton,
  Tooltip,
  TablePagination,
  TextField,
  Box,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import {StyledTableCell,HeaderTableCell,StyledTableRow} from "../Partials/TableStyle"



function TableData(props) {
  const [tableData, setTableData] = useState([]);
  const [load, setLoad] = useState(false);
  const [par] = useState(props.par);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(25);
  const [searchQuery, setSearchQuery] = useState("");
 let showEdit =true
 let showDelete=true
  const loadTableData = async () => {
    const response = await getReq(props.path);
    // showEdit = props.showEdit;
    // showDelete =props.showDelete;
    if(props.searchQuery) 
      {
        setSearchQuery(props.searchQuery)
      }
    setLoad(true);
    if (response.data?.length) {
      setTableData(response.data.reverse());
    } else {
      setTableData([]);
    }
  };
  useEffect(() => {
    // Reset page to 0 after a search
    setPage(0);
  }, [searchQuery]);
  const editClick = (item) => {
    props.editClick(item);
  };

  useEffect(() => {
    loadTableData();
  }, [props.path]);

  const deleteState = async (id) => {
    const shouldDelete = window.confirm("Are you sure to delete this item?");
    if (!shouldDelete) {
      return;
    }
    setLoad(true);
    if (props.deletePath) {
      const response = await putReq(props.deletePath, "", id);
      if (response.success) {
        setLoad(false);
        loadTableData();
        SuccessAlert({
          title: "Data Deleted",
          message: `${props.path} : Deleted Successfully`,
        });
      } else {
        setLoad(false);
        ErrorAlert({
          title: `${props.path} Delete: Error`,
          message: response.msg,
        });
      }
    } else {
      const response = await delReq(props.path, id);
      setLoad(true);
      if (response.success) {
        loadTableData();
        setLoad(false);
        SuccessAlert({
          title: "Data Deleted",
          message: `${props.path} : Deleted Successfully`,
        });
      } else {
        setLoad(true);
        ErrorAlert({
          title: `${props.path} Delete: Error`,
          message: response.msg,
        });
      }
    }
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleSearch = (event) => {
    setSearchQuery(event.target.value);
  };

  const filteredData = tableData.filter((item) => {
    return Object.values(item)
      .join(" ")
      .toLowerCase()
      .includes(searchQuery.toLowerCase());
  });

  const columnHeadings =
    tableData.length > 0
      ? Object.keys(tableData[0]).filter((key) => key !== "_id")
      : [];

  return (
    <React.Fragment>
      <div className="componet-sub2-title">
        <div className="justi-spacebt">
          <span>
            Total {props.path}: {tableData.length}
          </span>
          <div className="search-div">
            <label>Search : </label>
            <input
              value={searchQuery}
              onChange={handleSearch}
              variant="outlined"
              size="small"
              // className="search-field"
            />
          </div>
        </div>
      </div>

      {load ? (
        <TableContainer component={Paper}>
          <Table size="small" aria-label="a dense table">
            <TableHead>
              <StyledTableRow>
                <HeaderTableCell>Sl.No</HeaderTableCell>
                {columnHeadings.map((heading, index) => (
                  <HeaderTableCell key={index}>
                    {heading.charAt(0).toUpperCase() + heading.slice(1)}
                  </HeaderTableCell>
                ))}
                {(showEdit || showDelete) && (
                  <HeaderTableCell>Actions</HeaderTableCell>
                )}
              </StyledTableRow>
            </TableHead>
            <TableBody>
              {filteredData
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((item, index) => (
                  <StyledTableRow
                    key={item._id}
                    sx={{
                      backgroundColor: index % 2 === 0 ? '#f5f5f5' : 'white',
                    }}
                  >
                    <StyledTableCell sx={{ textAlign: 'center' }}>
                      {page * rowsPerPage + index + 1}
                    </StyledTableCell>
                    {columnHeadings.map((heading, i) => (
                      <StyledTableCell key={i}>{item[heading]}</StyledTableCell>
                    ))}
                    {par !== item._id ? (
                      (showEdit || showDelete) && (
                        <StyledTableCell>
                          {showEdit && (
                            <Tooltip title="Edit">
                              <IconButton onClick={() => editClick(item)}>
                                <MdModeEditOutline className="Edit-icon" />
                              </IconButton>
                            </Tooltip>
                          )}
                          {showDelete && (
                            <Tooltip title="Delete">
                              <IconButton onClick={() => deleteState(item._id)}>
                                <AiFillDelete className="Delete-icon" />
                              </IconButton>
                            </Tooltip>
                          )}
                        </StyledTableCell>
                      )
                    ) : (
                      <StyledTableCell></StyledTableCell>
                    )}
                  </StyledTableRow>
                ))}
            </TableBody>
          </Table>
          <TablePagination
            rowsPerPageOptions={[10, 25, 50, 100]}
            component="div"
            count={filteredData.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </TableContainer>
      ) : (
        <Loading />
      
      )}
    </React.Fragment>
  );
}

export default TableData;
